import {Params} from '@angular/router';

import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'organizationId',
  name: 'name',
};

export class OrganizationModel extends Model {
  name!: string;

  static getInstance(data: Params): OrganizationModel {
    const model = new OrganizationModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }
}
